<a class="ad-container cursor-pointer" (click)="onGotoAdDetail($event, ad)">
	<!-- Paid -->
	<div class="paid" *ngIf="ad.premium === '1' || ad.vip === '1'">
		<div class="stripe" [ngClass]="{ premium: ad.vip === '0', vip: ad.vip === '1' }"></div>
		<div
			class="label"
			[ngClass]="{
				premium: ad.vip === '0',
				vip: ad.vip === '1'
			}"
		>
			{{ ad.vip === '1' ? localeService.translations['ads']['ad']['n118'] : localeService.translations['ads']['ad']['n41'] }}
		</div>
	</div>

	<!-- Sold -->
	<div class="sold" *ngIf="ad?.sold === '1'">
		<span class="label">
			{{ localeService.translations['ads']['ad']['n111'] }}
		</span>
	</div>

	<div
		class="mb-2 mx-2"
		[ngClass]="{ 'button-container-rtl': localeService.lang !== 'en', 'button-container': localeService.lang === 'en' }"
		*ngIf="ad?.sold === '0'"
	>
		<button mat-button class="w-100 fg-white fs-11px fw-400" [disableRipple]="true" (click)="onOpenGallery($event, ad)">
			<img
				[src]="'assets/images/view-all-photos-icon.svg' | s3Image"
				class="mb-2px"
				[ngClass]="{ 'me-2': localeService.lang === 'en', 'ms-2': localeService.lang !== 'en' }"
			/>
			{{ localeService.translations['n703'] }}
		</button>
	</div>

	<!-- Favorite button -->
	<!-- Button showing when not marked favorite -->
	<app-button
		class="favorite"
		customClass="bg-darkest-grey"
		[btnType]="buttonType.MINI_FAB"
		[isStopPropagation]="true"
		(clicked)="onWatch(ad)"
		*ngIf="ad.watching === '0'"
	>
		<mat-icon class="favorite" icon>favorite_border</mat-icon>
	</app-button>
	<!-- Button showing when  marked favorite -->
	<app-button
		class="favorite"
		customClass="bg-darkest-grey"
		[btnType]="buttonType.MINI_FAB"
		[isStopPropagation]="true"
		(clicked)="onWatch(ad)"
		*ngIf="ad.watching === '1'"
	>
		<mat-icon class="favorite" [class.favorite--primary]="ad.watching === '1'" icon>favorite</mat-icon>
	</app-button>

	<!-- Ad images -->
	<div class="images">
		<button mat-button class="w-100 p-0" [disableRipple]="true">
			<img [src]="ad.images[0]?.name" />
		</button>
	</div>

	<!-- Contents -->
	<div class="contents">
		<div class="details">
			<div class="row mx-0 justify-content-between">
				<div class="col-auto px-0">
					<span class="price">&#36; {{ ad.price }}</span>
				</div>
				<div
					class="col-auto px-0 detail justify-content-center"
					[ngClass]="[ad['vip'] === '1' ? (ad['vipViews'] | vipViewsColor) : (ad['views'] | vipViewsColor)]"
				>
					<div class="icon-wrapper ms-16px">
						<mat-icon>remove_red_eye</mat-icon>
						<span class="ms-2px">{{ ad['vip'] === '1' ? ad['vipViews'] : ad['views'] }}</span>
						<ng-container *ngIf="ad?.['vipViews'] >= 10000 && ad?.['vipViews'] <= 19999">
							<img [src]="'assets/images/vip/eye-emoji.png' | s3Image" class="emoji-img" />
						</ng-container>
						<ng-container *ngIf="ad?.['vipViews'] > 19999">
							<img [src]="'assets/images/vip/fire-emoji.png' | s3Image" class="emoji-img" />
						</ng-container>
					</div>
				</div>
			</div>

			<h2 class="title mb-0">{{ ad.title }}</h2>

			<div class="row mx-0" *ngIf="ad['subCatID'] === '291'">
				<div class="col-6 px-0" *ngFor="let property of itemProperties">
					<div class="d-inline-block">
						<mat-icon class="fg-grey property-icons fs-16px">{{ property.icon }}</mat-icon>
					</div>
					<span class="fg-grey ms-2px fs-11px align-top me-2">{{ property?.['descriptionItem'] }}</span>
				</div>
			</div>

			<div class="row mx-0" *ngIf="ad['subCatID'] !== '291'">
				<div class="col-auto px-0">
					<div class="d-inline-block">
						<mat-icon class="fg-grey property-icons fs-16px">place</mat-icon>
					</div>
					<span class="fg-grey ms-2px fs-11px align-top me-2">{{ ad.location }}</span>
				</div>
			</div>

			<p class="description mb-2">{{ ad.description }}</p>

			<!-- <div class="col-12 fg-accent text-end d-flex justify-content-start px-0" *ngIf="ad?.vip === '1'" [routerLink]="['/vip']">
				<mat-icon class="fs-16px info mt-10px d-flex justify-content-center">info</mat-icon>
				<span class="vip-info fs-11px">{{ localeService.translations['vip']['n181'] }}</span>
			</div> -->
		</div>
	</div>

	<!-- Actions -->
	<div class="actions border-top px-2 py-2" [ngClass]="{ 'mt-25px': ad['subCatID'] !== '291' }">
		<!-- Call -->
		<app-button
			class="call"
			customClass="w-100"
			[isDisabled]="ad.sold === '1'"
			[label]="ad.phone | maskPhone : toggleFullPhoneNumber"
			svgIcon="phone"
			[isStopPropagation]="true"
			(clicked)="onCall(ad)"
		></app-button>

		<div class="ad-item-chats-8px" *ngIf="ad.seller?.contactTypeWhatsapp == '1' && ad.sold === '0'">
			<!-- WhatsApp -->
			<app-button class="icon" svgIcon="whatsapp-2" [btnType]="buttonType.ICON" [isStopPropagation]="true" (clicked)="onCallPlatform(ad)"></app-button>
		</div>
	</div>
</a>
